import mixpanel from 'mixpanel-browser';
import { useGlobalDependencyProvider } from '../di/useGlobalDependencyProvider';

export function setupMixpanel(projectKey: string): {
  mixpanel: typeof mixpanel;
} {
  const di = useGlobalDependencyProvider();
  const config = di.inject('config');
  let key;
  if (config.isTestEnvironment()) {
    // TODO: get from env
    const mixpanelStagingProjectKey = '564a3612134a8ca4cd7cf30a99cbf50b';
    console.info('Test Environment detected. Using Mixpanel Staging Project.');

    key = mixpanelStagingProjectKey;
  } else {
    key = projectKey;
  }

  try {
    if (config.isMixpanelActive()) {
      /* eslint-disable @typescript-eslint/naming-convention */

      mixpanel.init(key, {
        debug: false,
        track_pageview: true,
        disable_persistence: true,
        ip: false,
        api_host: config.mixpanelEndpointUrl(),
        ignore_dnt: true,
        /* eslint-enable @typescript-eslint/naming-convention */
      });
    }
  } catch (e) {
    console.error(e);
  }
  return { mixpanel };
}
